import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NewInstrumentForm.html?raw';


import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import Edit from '../../moreCore/UI/Edit/Edit';
class NewInstrumentForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    dlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private inputCategory: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputInstrumentName: MdsLax<InstanceType<typeof Edit>>;
    private instrument: Instrument;

    setInstrument(instrument: Instrument): void {
        this.instrument = instrument;
        this.inputCategory.setValue(this.instrument.ref_instruments_categorie);
        this.inputInstrumentName.setValue(this.instrument.description);
        //console.log(this.inputCategory);
    }

    getInstrument(): Instrument {
        return this.instrument;
    }

    getData(): Instrument {
        var description = this.inputInstrumentName.getValue() as string;
        var category = this.inputCategory.getSelectedEntity() as InstrumentCategory;
        console.log(category);
        var cowner = this.getCurrentUserDisplayName() as string;
        var gDisp_1 = description + " - " + cowner;
        //Find a way to get displayname of owner
        var newInstrumentFormData: Instrument = {
            description: description,
            cowner: cowner,
            ID: (Math.round((Math.random() * 1000000000))).toString(),
            ref_instruments_categorie: category,
            Classname: "external_instrument",
            gDisp_1: gDisp_1
        }
        return newInstrumentFormData;
    }

    private _onInputChange(): void {
        if (this._validateInput()) {
            this.emit("valid");
        }
    }

    private _validateInput(): boolean {
        return this.inputInstrumentName.getValue() !== null && this.inputCategory.getValue() !== null
    }

    private _onSetCategoriesSuccess(data: CategoryData): void {
        this.inputCategory.setSelectionListLEGACY(data, null, "description", "ID");
    }

    private _onSetCategoriesError(error: more.requestErrorMessage): void {
        console.log(error.Message);
    }

    postCreate(): void {
        // Controls zeichnen bevor die StatefulSection losstartet
        this.RequestManager.handleAs = "jsonWithDate";
        this.RequestManager.callfunction("Webtool_API_EmployeeProfile__LoadInstrumentCategories", "",
            lang.hitch(this, this._onSetCategoriesSuccess), lang.hitch(this, this._onSetCategoriesError));
        super.postCreate.apply(this, arguments as any);
        // -----> ab hier sind die sections und data-keys registriert
        // initial readOnly
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(NewInstrumentForm);